import { Component, OnInit } from '@angular/core';

import { DataService, Loading } from 'src/app/Services/Data/data.service';
import { Salesforce, OrgAdminSettings } from 'src/app/Services/Data/data.model';

import { DatabindingService } from '../../../Services/Databinding/databinding.service';

enum ButtonTypes {
  template = 'template',
  bulk = 'bulk',
  attachment = 'attachment',
  attachment_group = 'attachment_group',
  merge_attachments = 'merge_attachments',
  quote = 'quote'
}

interface SuggestionTpl {
  value: string;
  label: string;
}

interface SuggestionTplSetting {
  id: string;
  setting_name: string;
}

@Component({
  selector: 'app-admin-page',
  templateUrl: './admin-page.component.html',
  styleUrls: ['./admin-page.component.sass']
})
export class AdminPageComponent implements OnInit {
  userSFData: Salesforce;
  orgAdminSettings: OrgAdminSettings;
  sn_token: string;
  targetRole = 'system administrator';

  isUserHasAccess = false;
  isUpdateChanges = false;
  isSomethingWrong = false;
  is_creating_button_popup_open = false;

  // objectList = [];
  layoutsList = [];
  loadsCount = 0;

  // error
  error_messages: any = [];

  // Loading
  loading: Loading;

  // for wizard
  btnTypes = ButtonTypes;
  sfObjectsList = [];
  sfCurrObjMetaList = [];
  // template_settings = [];
  isQuoteButtonCanBeChosen = true;
  addingButtonToLayoutResults: any = [];
  failedCreatingButtonNames: any = [];

  selectedLayoutsForCreatingBtnFromWizard = [];
  selectedButtonType: string = this.btnTypes.template;
  selectedObjectTypeForBulk = '';
  selectedObjectFieldForBulk = null;
  preselectedDocumentId = '';
  selectedTemplateSettingId = '';
  selectedAdditionalParams = [];
  redirectUrl = '';
  isWrongUrl = false;
  customButtonNames = {
    merge_attachments: 'SignNow Merge Attachments',
    attachment_group: 'SignNow Attachment Group',
    attachment: 'SignNow Attachments',
    template: 'SignNow Templates',
    quote: 'SignNow Quotes',
    bulk: 'Bulk Invite'
  };
  selectedCustomButtonName = this.customButtonNames.template;

  chosenPreselectedDocument: SuggestionTpl = null;
  templateSuggestionList: SuggestionTpl[] = [];
  filteredTemplateSuggestionList: SuggestionTpl[] = [];

  chosenTplSetting: SuggestionTplSetting = null;
  templateSettingsSuggestionList: SuggestionTplSetting[] = [];
  filteredTemplateSettingsSuggestionList: SuggestionTplSetting[] = [];

  pushbackChoice: string = 'save-as-attachments';

  buttonDescriptions = {
    merge_attachments:
      'Merge as many documents attached to Salesforce records as you need into a single document.',
    attachment_group: 'Send a group of documents attached to a Salesforce record out to be e-signed.',
    attachment: 'Send a document attached to a Salesforce record out to be e-signed.',
    template: 'Send out documents or groups of documents to be e-signed.',
    quote: 'Send out Quotes via an email or direct link to be e-signed (for a Quotes object only).',
    bulk: 'Send out documents to be e-signed by multiple recipients all at once. Attach signed copies to the Salesforce records that they were sent from and to each record they were sent to.'
  };

  constructor(private dataService: DataService, private databindingService: DatabindingService) {}

  ngOnInit(): void {
    this.loading = this.dataService.getLoading();
    this.updateLoading(true, ' Validating that user is admin for this org.');
    this.userSFData = this.dataService.getSalesforceData();

    this.dataService.getUserRole().subscribe(
      (userRole: string) => {
        if (userRole && userRole.toLocaleLowerCase() === this.targetRole) {
          this.isUserHasAccess = true;
          this.getOrgAdminSettings();
          this.loadLayoutList();
        } else {
          this.updateLoading(false);
        }
      },
      (err) => {
        this.errorHandler(err);
      }
    );

    this.loadAllTemplatesSettings();
    this.loadAllSalesforceObjectsList();
  }

  private getOrgAdminSettings(): void {
    this.dataService.getOrgAdminSettingsById(this.userSFData.sf_org_id).subscribe(
      (orgAdminSettings: any) => {
        if (orgAdminSettings && orgAdminSettings.sf_org_id) {
          this.orgAdminSettings = orgAdminSettings;

          if (orgAdminSettings.is_not_save_document || orgAdminSettings.is_save_document === false) {
            this.pushbackChoice = 'dont-save';
          } else if (orgAdminSettings.is_save_as_file) {
            this.pushbackChoice = 'save-as-file';
          } else {
            this.pushbackChoice = 'save-as-attachment';
          }
        } else {
          this.pushbackChoice = 'save-as-attachment';
        }

        if (++this.loadsCount === 2) {
          this.updateLoading(false);
        }
      },
      (err) => {
        this.errorHandler(err);
      }
    );
  }

  private errorHandler(err, errorMessage = 'Something went wrong - try again!'): void {
    err = err || errorMessage;
    // this.isSomethingWrong = true;
    this.updateError(errorMessage);
    this.updateLoading(false);
    console.log('error', err);
  }

  // updateAdminSettings(isPushBackOn: HTMLInputElement): void {
  updateAdminSettings(): void {
    this.isUpdateChanges = false;
    this.isSomethingWrong = false;

    const data = {
      sf_org_id: this.userSFData.sf_org_id,
      is_not_save_document: false,
      is_save_as_attachment: false,
      is_save_as_file: false
    };

    switch (this.pushbackChoice) {
      case 'dont-save':
        data.is_not_save_document = true;
        break;
      case 'save-as-file':
        data.is_save_as_file = true;
        break;
      case 'save-as-attachment':
        data.is_save_as_attachment = true;
        break;
      default:
        data.is_save_as_attachment = true;
        break;
    }

    this.dataService
      .apiPostCall('/api/update_admin_settings', JSON.stringify(data))

      .subscribe((response) => {
        if (response && response['sn_msg']) {
          this.isUpdateChanges = true;
        } else {
          this.isSomethingWrong = true;
        }
      });
  }

  loadLayoutList() {
    this.updateLoading(true, 'Loading Layouts...');
    this.selectedLayoutsForCreatingBtnFromWizard = [];

    this.dataService.getAllLayoutsList().subscribe(
      (response) => {
        if (response) {
          this.layoutsList = response;
        }

        if (++this.loadsCount >= 2) {
          this.updateLoading(false);
        }
      },
      (err) => {
        this.errorHandler(err, 'Layouts cannot be displayed.');
      }
    );
  }

  loadAllSalesforceObjectsList() {
    this.dataService.getAllSalesforceObjectsList().subscribe((response) => {
      if (response) {
        response.forEach((item) => {
          if (item.updateable) {
            this.sfObjectsList.push(item.label);
          }
        });
        this.sfObjectsList.sort((a, b) => {
          const aa = a.toLowerCase(),
            bb = b.toLowerCase();
          if (aa > bb) {
            return 1;
          }
          if (aa < bb) {
            return -1;
          }
          return 0;
        });
      } else {
        // this.isSomethingWrong = true;
      }
    });
  }

  // on the rows that take part in the filtering there is an added class "s-mark"
  // and an attribute "data-search-name" with template name
  search_layouts(value, targetBlockId: string) {
    let filter, table, elementsWithName;
    filter = value.toUpperCase();
    table = document.getElementById(targetBlockId);
    elementsWithName = table.querySelectorAll('.s-mark');

    // Loop through all rows, and hide those who don't match the search query
    for (let i = 0; i < elementsWithName.length; i++) {
      const dataGroupName = elementsWithName[i].dataset.searchName;

      if (filter === '' || dataGroupName.toUpperCase().indexOf(filter) > -1) {
        elementsWithName[i].style.display = '';
      } else {
        elementsWithName[i].style.display = 'none';
      }
    }
  }

  createButtonsUpdateLayouts(
    layoutsForCreatingBtn,
    buttonName = this.customButtonNames.template,
    additionalParams = '',
    callbackFn = null
  ) {
    if (this.userSFData && this.userSFData.sf_user_id && this.userSFData.sf_token !== '') {
      this.clearErrors();
      this.updateLoading(true, 'Creating Buttons...');
      this.addingButtonToLayoutResults = [];
      this.failedCreatingButtonNames = [];
      // first part - creating buttons

      const data = {
        sf_token: this.userSFData.sf_token,
        instance_url: this.userSFData.instance_url,
        buttonName: buttonName,
        layouts: JSON.stringify(Array.from(layoutsForCreatingBtn)),
        additionalParams: additionalParams,
        description: this.buttonDescriptions[this.selectedButtonType] || ''
      };

      if (layoutsForCreatingBtn.length) {
        this.dataService
          .apiPostCall('/api/create_weblink', data)

          .subscribe(
            (res) => {
              if (res) {
                if (res.fullName && res.success) {
                  // case with one button
                  this.updateLayouts(layoutsForCreatingBtn, res.fullName.split('.')[1], callbackFn);
                } else if (res.length) {
                  // case with more than one button
                  let isAnySuccess = false;
                  for (let i = 0; i < res.length; i++) {
                    if (res[i].success) {
                      isAnySuccess = true;
                      this.updateLayouts(layoutsForCreatingBtn, res[i].fullName.split('.')[1], callbackFn);
                      break;
                    }
                  }

                  if (!isAnySuccess) {
                    this.resetWizardData();
                    this.errorHandler(
                      null,
                      'No buttons were created - please try again. The custom button name must contain only alphanumeric characters, begin with a letter, and be unique.'
                    );
                  }
                } else {
                  this.resetWizardData();
                  this.errorHandler(
                    null,
                    'Button was not created - please try again. The custom button name must contain only alphanumeric characters, begin with a letter, and be unique.'
                  );
                }
              } else {
                this.resetWizardData();
                this.errorHandler('');
              }
            },
            () => {
              // const error = err.json();
              this.resetWizardData();
              layoutsForCreatingBtn.forEach((item) => {
                this.failedCreatingButtonNames.push({ name: item.name });
              });
              this.updateLoading(false);
            }
          );
      } else {
        this.updateLoading(false);
      }
    } else {
      this.resetWizardData();
      console.log('something went wrong!');
    }
  }

  private updateLayouts(layoutsForCreatingBtn, buttonName, callbackSuccessFn = null) {
    this.updateLoading(true, 'Updating Layouts...');

    const dataForUpdateLayouts = {
      sf_token: this.userSFData.sf_token,
      instance_url: this.userSFData.instance_url,
      buttonFullName: buttonName,
      layouts: JSON.stringify(layoutsForCreatingBtn)
    };

    this.dataService
      .apiPostCall('/api/update_layouts_with_sn_buttons', dataForUpdateLayouts)

      .subscribe(
        (result) => {
          this.loadLayoutList();
          this.addingButtonToLayoutResults = [].concat(result);

          for (let i = 0; i < this.addingButtonToLayoutResults.length; i++) {
            if (this.addingButtonToLayoutResults[i].fullName) {
              this.addingButtonToLayoutResults[i].fullName = this.addingButtonToLayoutResults[i].fullName
                .replace('%28', '(')
                .replace('%29', ')');
            }
          }

          // getting difference between start array of layouts with result array where we added buttons
          this.failedCreatingButtonNames = layoutsForCreatingBtn.filter((currItem) => {
            return (
              this.addingButtonToLayoutResults.filter(function (comparingItem) {
                return currItem.name === comparingItem.fullName.split('-')[1];
              }).length === 0
            );
          });

          if (typeof callbackSuccessFn === 'function') {
            callbackSuccessFn();
          }
        },
        (err) => {
          layoutsForCreatingBtn = [];
          this.resetWizardData();
          this.errorHandler(err);
        }
      );
  }

  clearErrors() {
    this.error_messages = [];
  }
  updateLoading(state: boolean, msg: string = '') {
    this.loading.update(state, msg);
  }
  updateError(msg: string) {
    this.error_messages = [];
    this.error_messages.push(msg);
  }
  removeErrorMessage(error_message) {
    for (let i = 0; i < this.error_messages.length; i++) {
      if (error_message === this.error_messages[i]) {
        // delete this.error_messages[i];
        this.error_messages.splice(i, 1);
      }
    }
  }

  /* WIZRAD */

  addLayoutToUpdateFromWizard(layoutItem: any, checkbox: HTMLInputElement, suggestionTplInput) {
    if (checkbox.checked) {
      this.selectedLayoutsForCreatingBtnFromWizard.push(layoutItem);
    } else {
      if (this.selectedLayoutsForCreatingBtnFromWizard.length) {
        this.selectedLayoutsForCreatingBtnFromWizard.splice(
          this.selectedLayoutsForCreatingBtnFromWizard.indexOf(layoutItem),
          1
        );
      }
    }

    let isQuoteAvailable = true;
    for (const layoutItm of this.selectedLayoutsForCreatingBtnFromWizard) {
      if (layoutItm.name.toLowerCase().indexOf('quote') === -1) {
        isQuoteAvailable = false;
        if (this.selectedButtonType === this.btnTypes.quote) {
          const firstTypeButtonChoise = <HTMLInputElement>(
            document.querySelector('#button-types-list .wizard__radio')
          );

          firstTypeButtonChoise.checked = true;
          this.changeButtonType(firstTypeButtonChoise.value, suggestionTplInput);
        }
        break;
      }
    }

    this.isQuoteButtonCanBeChosen = isQuoteAvailable;
  }

  changeButtonType(buttonType, suggestionTplInput) {
    if (suggestionTplInput) {
      suggestionTplInput.value = '';
    }

    this.selectedButtonType = buttonType;
    this.chosenPreselectedDocument = null;
    this.selectedCustomButtonName =
      this.customButtonNames[this.selectedButtonType] || this.customButtonNames.template;
  }

  getSfObjectMeta(objectTypeStr) {
    this.databindingService.getSalesforceObjectMetadata(objectTypeStr).subscribe(
      (result) => {
        this.sfCurrObjMetaList = result || [];
      },
      (error) => {
        console.log('error', error);
      }
    );
  }

  onChangeSfObjectType() {
    this.getSfObjectMeta(this.selectedObjectTypeForBulk);
  }

  loadAllTemplatesSettings() {
    const params = {
      sf_token: this.userSFData.sf_token,
      instance_url: this.userSFData.instance_url
    };

    this.dataService
      .apiGetCall('/api/get_all_templates_settings_names_ids', { params })

      .subscribe(
        (result) => {
          this.filteredTemplateSettingsSuggestionList = this.templateSettingsSuggestionList = result;
          // this.template_settings = result;
        },
        (error) => {
          if (error.status === 504 || error.status === '504') {
            this.updateError('Failed to load Template Setting.');
          } else {
            // this.updateError(error.error);
          }
        }
      );
  }

  // changeTemplateSetting(templateSettingId) {
  //   this.selectedTemplateSettingId = templateSettingId;
  // }

  changeAdditionalParams(checkbox: HTMLInputElement) {
    if (checkbox.checked) {
      this.selectedAdditionalParams.push(checkbox.value);
    } else {
      if (this.selectedAdditionalParams.length) {
        this.selectedAdditionalParams.splice(this.selectedAdditionalParams.indexOf(checkbox.value), 1);
      }

      // if redirect unchecked
      if (checkbox.value === 'redirect') {
        this.redirectUrl = '';
      }
    }
  }

  isCheckedAdditionalParam(paramName: String = '') {
    return this.selectedAdditionalParams.includes(paramName);
  }

  openClosePopup(popupName, state = true) {
    if (popupName === 'createButton') {
      this.is_creating_button_popup_open = state;

      if (state === true) {
        this.resetWizardData();
      }

      if (!this.templateSuggestionList.length) {
        this.getAllFoldersAndDocuments();
      }
    }
  }

  generateCustomButton() {
    this.resetWizardResults();

    if (this.selectedLayoutsForCreatingBtnFromWizard.length === 0) {
      return;
    }

    this.is_creating_button_popup_open = false;

    let resultStringParams;
    let viewParam = '';
    let bulkInviteType = '';
    let bulkEmailField = '';
    let additionalParams = '';
    let redirectUrlparam = '';
    let templateSettings = '';
    let preselectedDocument = '';

    switch (this.selectedButtonType) {
      case this.btnTypes.template:
        viewParam = '&view=templates';
        break;
      case this.btnTypes.attachment:
        viewParam = '&view=attachments';
        break;
      case this.btnTypes.attachment_group:
        viewParam = '&view=attachments-group';
        break;
      case this.btnTypes.merge_attachments:
        viewParam = '&view=merge-attachments';
        break;
      case this.btnTypes.quote:
        viewParam = '&view=quotes';
        break;
      case this.btnTypes.bulk:
        viewParam = '&view=bulk_invite';
        break;
      default:
        viewParam = '&view=templates';
        break;
    }

    if (this.selectedButtonType === this.btnTypes.bulk) {
      bulkInviteType = `&bulk_invite_type=${this.selectedObjectTypeForBulk}`;
      bulkEmailField = `&bulk_email_field=${this.selectedObjectFieldForBulk}`;
    }

    for (let i = 0; i < this.selectedAdditionalParams.length; i++) {
      additionalParams += `&${this.selectedAdditionalParams[i]}=true`;
    }

    if (this.redirectUrl) {
      try {
        const decodedRedirectUrl = decodeURIComponent(this.redirectUrl); // if user insert already encoded string
        redirectUrlparam = `&redirectUrl=${encodeURIComponent(decodedRedirectUrl)}`;
      } catch {
        this.isWrongUrl = true;
        return;
      }
    }

    if (this.chosenPreselectedDocument && this.chosenPreselectedDocument.value) {
      if (
        this.selectedButtonType === this.btnTypes.attachment ||
        this.selectedButtonType === this.btnTypes.attachment_group
      ) {
        preselectedDocument = `&attachment_id=${this.chosenPreselectedDocument.value}`;
      } else if (
        this.selectedButtonType === this.btnTypes.template ||
        this.selectedButtonType === this.btnTypes.bulk
      ) {
        preselectedDocument = `&template_id=${this.chosenPreselectedDocument.value}`;
      }
    }

    // todo
    if (this.chosenTplSetting && this.chosenTplSetting.id) {
      templateSettings = `&template_setting=${this.chosenTplSetting.id}`;
    }
    resultStringParams =
      viewParam +
      bulkInviteType +
      bulkEmailField +
      additionalParams +
      redirectUrlparam +
      preselectedDocument +
      templateSettings;

    this.createButtonsUpdateLayouts(
      this.selectedLayoutsForCreatingBtnFromWizard,
      this.selectedCustomButtonName,
      resultStringParams,
      this.resetWizardData.bind(this)
    );
  }

  clearInputs(inputsList) {
    inputsList.forEach((input) => (input.value = ''));
  }

  resetWizardData() {
    this.selectedLayoutsForCreatingBtnFromWizard = [];
    this.selectedButtonType = this.btnTypes.template;
    this.selectedObjectTypeForBulk = '';
    this.selectedObjectFieldForBulk = null;
    // this.preselectedDocumentId = '';
    this.chosenPreselectedDocument = null;
    // this.selectedTemplateSettingId = '';
    this.chosenTplSetting = null;
    this.selectedAdditionalParams = [];
    this.selectedCustomButtonName = this.customButtonNames.template;
    this.redirectUrl = '';
    this.isQuoteButtonCanBeChosen = true;
  }

  resetWizardResults() {
    this.addingButtonToLayoutResults = [];
    this.failedCreatingButtonNames = [];
    this.isWrongUrl = false;
  }

  isCreateButtonDisabled() {
    if (
      this.selectedLayoutsForCreatingBtnFromWizard.length === 0 ||
      this.selectedCustomButtonName.trim().length === 0
    ) {
      return true;
    } else if (
      this.selectedButtonType === this.btnTypes.bulk &&
      (!this.selectedObjectTypeForBulk || !this.selectedObjectFieldForBulk)
    ) {
      return true;
    }

    return false;
  }

  getAllFoldersAndDocuments() {
    this.updateLoading(true, 'Getting SignNow folders and documents.');

    this.dataService
      .apiGetCall('/api/folders')

      .subscribe(
        (result) => {
          for (let i = 0; i < result.folders.length; i++) {
            if (this.dataService.isAllowedFolder(result.folders[i].name)) {
              this.getDocumentsFromFolder(result.folders[i].id, (folder) => {
                this.filteredTemplateSuggestionList = this.templateSuggestionList;
                folder.documents.forEach((document) => {
                  this.templateSuggestionList.push({
                    value: document.id,
                    label: document.document_name
                  });
                });

                // sorting by alphabet
                if (this.templateSuggestionList.length) {
                  this.templateSuggestionList.sort((a, b) => {
                    const labelA = a.label.toLowerCase();
                    const labelB = b.label.toLowerCase();

                    return labelA < labelB ? -1 : 1;
                  });
                }
              });
            }
          }
          this.updateLoading(false, '');
        },
        (error) => {
          this.updateError(error.error);
          this.updateLoading(false, '');
          return;
        }
      );
  }

  getDocumentsFromFolder(folder_id: string, callback) {
    this.dataService
      .apiGetCall('/api/templates_in_folder?folder_id=' + folder_id)

      .subscribe((result) => {
        callback(result);
      });
  }

  // PRESELECTED TEMPLATE
  filteringTemplateSuggestion(tplName) {
    if (tplName) {
      this.filteredTemplateSuggestionList = this.templateSuggestionList.filter((tplSuggest) =>
        tplSuggest.label.toLowerCase().includes(tplName.trim().toLocaleLowerCase())
      );
    } else {
      this.filteredTemplateSuggestionList = this.templateSuggestionList;
    }
    this.chosenPreselectedDocument = null;
  }

  chooseTplHandler(tplSuggestionItem, suggestionTplSelector, suggestionTplInput) {
    this.chosenPreselectedDocument = tplSuggestionItem;
    suggestionTplSelector.classList.remove('open');
    suggestionTplInput.value = this.chosenPreselectedDocument ? this.chosenPreselectedDocument.label : '';
  }

  onBlurSuggestionTplInputHandler(suggestionTplInput, suggestionTplSelector) {
    setTimeout(() => {
      if (
        !this
          .chosenPreselectedDocument /*|| !this.templateSuggestionList.some(tplSuggest => tplSuggest.label.toLocaleLowerCase() === suggestionTplInput.value.trim().toLowerCase())*/
      ) {
        // this.chosenPreselectedDocument = null;

        this.chosenPreselectedDocument = this.templateSuggestionList.find(
          (tplSuggest) =>
            tplSuggest.label.toLocaleLowerCase() === suggestionTplInput.value.trim().toLowerCase()
        );

        if (!this.chosenPreselectedDocument) {
          this.chosenPreselectedDocument = {
            value: suggestionTplInput.value,
            label: suggestionTplInput.value
          };
          this.filteredTemplateSuggestionList = this.templateSuggestionList;
        }
      }

      suggestionTplSelector.classList.remove('open');
    }, 250);
  }
  // END PRESELECTED TEMPLATE

  // TEMPLATE SETTINGS
  filteringTemplateSettingSuggestion(tplName) {
    if (tplName) {
      this.filteredTemplateSettingsSuggestionList = this.templateSettingsSuggestionList.filter((tplSuggest) =>
        tplSuggest.setting_name.toLowerCase().includes(tplName.trim().toLocaleLowerCase())
      );
    } else {
      this.filteredTemplateSettingsSuggestionList = this.templateSettingsSuggestionList;
    }
    this.chosenTplSetting = null;
  }

  chooseTplSettingHandler(tplSettingSuggestionItem, suggestionTplSettingSelector, suggestionSettingTplInput) {
    this.chosenTplSetting = tplSettingSuggestionItem;
    suggestionTplSettingSelector.classList.remove('open');
    suggestionSettingTplInput.value = this.chosenTplSetting ? this.chosenTplSetting.setting_name : '';
  }

  onBlurSuggestionTplSettingInputHandler(suggestionSettingTplInput, suggestionTplSettingSelector) {
    setTimeout(() => {
      if (
        !this
          .chosenTplSetting /*|| !this.templateSettingsSuggestionList.some(tplSuggest => tplSuggest.setting_name.toLocaleLowerCase() === suggestionSettingTplInput.value.trim().toLowerCase()) */
      ) {
        // this.chosenTplSetting = null;
        suggestionSettingTplInput.value = '';
        this.filteredTemplateSettingsSuggestionList = this.templateSettingsSuggestionList;
      }

      suggestionTplSettingSelector.classList.remove('open');
    }, 250);
  }
  // END TEMPLATE SETTINGS
}
